module.exports = __webpack_public_path__ + "svg/slim-jacket.f07b0772c23de0396750a86b8391fe23.svg";